import { useRequest } from 'ahooks'
import { useEffect } from 'react'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'

import { addOrUpdateContract, delContract, getContract, relieveContracts } from './service'

export default ({ employee_id, onConfirm }: any) => {
  const { open, modalData, setModalData, onCancel, onOpen } = usePopup({})
  const onChange = (_dataSource?: any) => setModalData({ dataSource: _dataSource })
  useEffect(() => {
    if (employee_id) {
      runQuery()
    }
  }, [employee_id])
  // 查询
  const { run: runQuery } = useRequest(() => getContract([employee_id]), {
    manual: true,
    onSuccess: (result: any) => {
      const { data } = result
      onChange(data)
      onCancel()
    },
    onError: ({ message }) => {
      console.log('error', message)
      onChange([])
    }
  })
  // 解除合同
  const { run: runRelieveContracts, loading: relieveContractsLoading } = useRequest(
    relieveContracts,
    {
      manual: true,
      onSuccess: (result: any) => {
        const { code } = result
        if (code === 2000) {
          runQuery()
        }
      },
      onError: ({ message }) => {
        console.log('error', message)
      }
    }
  )
  // 保存
  const { run: runSave, loading: saveLoading } = useRequest(addOrUpdateContract, {
    manual: true,
    onSuccess: (result: any) => {
      const { code } = result
      if (code === 2000) {
        runQuery()
      }
    },
    onError: ({ message }) => {
      console.log('error', message)
    }
  })
  // 删除
  const { run: runDelete, loading: delLoading } = useRequest(delContract, {
    manual: true,
    onSuccess: (result: any) => {
      const { code } = result
      if (code === 2000) {
        runQuery()
      }
    },
    onError: ({ message }) => {
      console.log('error', message)
    }
  })

  useEffect(() => {
    if (onConfirm) onConfirm(modalData?.dataSource)
  }, [modalData?.dataSource])
  return {
    open,
    modalData,
    onCancel,
    onOpen,
    runDelete,
    runQuery,
    runSave,
    runRelieveContracts,
    relieveContractsLoading,
    saveLoading,
    delLoading
  }
}
